<template>
  <v-container fluid v-if="!loading">
    <SubHeader
      :title="title"
      :toClone="true"
      @edit="edit"
      @saveChanges="saveChanges"
      @cencel="cencel"
      @delEl="delEl"
      @clone="clone"
    />
    <RForm
      :editable="editable"
      :fields="fields"
      :values="values"
    />
    <div>
      <span class="text--disabled">מספר פנימי:</span>
      <span class="caption">{{ id }}</span>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import RForm from "@/components/app/common/Form/RForm";
import SubHeader from "@/components/app/common/Form/SubHeader";

export default {
  name: "Home",
  props: {
    id: {},
    title: {},
    fieldsGetter: {
      required: true,
    },
    fieldsGetFunctionName: {
      required: true,
    },
    getFieldValuesFunc: {
      required: true,
    },
    updateFieldValuesFunc: {
      required: true,
    },
    removeFieldValuesFunc: {
      required: true,
    },
    addFieldValuesFunc: {
      required: true,
    },
  },
  data: () => ({
    values: {},
    editable: true,
  }),
  methods: {
    edit() {
      this.editable = true;
    },
    async cencel() {
      await this.getContactPerson();
      this.editable = false;
    },
    async saveChanges() {
      await this.$store.dispatch("loading", true);
      this.values.id = this.id;
      await this.$store.dispatch(this.updateFieldValuesFunc, this.values);
      this.editable = false;
      await this.$store.dispatch("loading", false);
    },
    async delEl() {
      await this.$store.dispatch("loading", true);
      await this.$store.dispatch(this.removeFieldValuesFunc, this.id);
      this.editable = false;
      await this.$store.dispatch("loading", false);
    },
    async clone() {
      await this.$store.dispatch("loading", true);
      await this.$store.dispatch(this.addFieldValuesFunc, this.values);
      this.editable = false;
      await this.$store.dispatch("loading", false);
    },
    async getContactPerson() {
      let cp = await this.$store.dispatch(this.getFieldValuesFunc, this.id);
      this.values = Object.assign(this.values, cp);
    },
  },
  components: {
    SubHeader,
    RForm,
  },
  async created() {
    await this.$store.dispatch("loading", true);
    await this.getContactPerson();
    await this.$store.dispatch(this.fieldsGetFunctionName);
    this.editable = false;
    await this.$store.dispatch("loading", false);
  },
  computed: {
    ...mapGetters(["loading"]),
    fields() {
      return this.$store.getters[this.fieldsGetter];
    },
  },
};
</script>